import { ScoreType } from '../../../../../../store/admin/eventFormats/store';
import { TIFormatPrefix } from '../../../../../../store/admin/roundFormats/store';
import { IResult } from '../../../../../../store/admin/roundResults/store';

import { getResultFieldName } from './getResultFieldName';

export const isResultTied = (result: IResult, prefix: TIFormatPrefix, scoreType: ScoreType) =>
  result[getResultFieldName(prefix, scoreType, 'Tie') as keyof IResult];
